import { useState } from 'react';
import useAsyncEffect from './useAsyncEffect';

const useMemoAsync = <Fn extends (...args: any[]) => any>(
    callback: Fn,
    deps: any[],
    initialValue: Awaited<ReturnType<Fn>>
) => {
    const [result, setResult] = useState<Awaited<ReturnType<Fn>>>(initialValue);

    useAsyncEffect(async () => {
        const res = await callback();
        setResult(res ?? initialValue);
    }, [...deps]);

    return result;
};

export default useMemoAsync;
